import type { Host } from '@elliemae/em-ssf-guest'
import { router } from '..'

const mockOrigin = {
  id: '_originId',
  partnerAccessToken: '_partnerToken',
  context: 'lender',
}

type RequestType = {
  request: {
    type: string
    options?: {
      vendor: string
      product: string
    }
  }
}

// TODO: remove these ts-ignores
export const DEV_HOST: Promise<Host> = new Promise(res =>
  res({
    connect: () => console.debug('connecting'),
    ready: () => console.debug('ready'),
    getObject: (key: 'transaction' | 'application') => {
      console.debug(`Getting {${key}} object...`)
      switch (key) {
        case 'transaction':
          return new Promise(res => {
            res({
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              refreshOrigin: async () =>
                new Promise(res => {
                  console.debug('refreshing origin')
                  res(mockOrigin)
                }),
              getOrigin: async () =>
                new Promise(res => {
                  console.debug('refreshing origin')
                  res(mockOrigin)
                }),
              create: (request: RequestType) => {
                console.debug('Creating\n', request)
                return Promise.resolve({
                  id: 'TRANSACTION_GUID',
                })
              },
              close: async () => {
                console.debug('Closing Transaction')
                await router.navigate({ to: '/dev' })
              },
              update: (request: RequestType) => {
                console.debug('Updating\n', request)
                return Promise.resolve({
                  id: 'TRANSACTION_GUID',
                })
              },
            })
          })
        case 'application':
          return new Promise(res => {
            res({
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              getCapabilities: async () =>
                new Promise(res => {
                  console.debug('Getting Capabilities')
                  res({})
                }),
              open: async () =>
                new Promise<void>(res => {
                  console.debug('Application Open')
                  res()
                }),
              openModal: async () =>
                new Promise<void>(res => {
                  console.debug('Application Open Modal')
                  res()
                }),
            })
          })
      }
    },
    setLogLevel: () => console.debug('setLogLevel'),
    subscribe: () => 0,
    unsubscribe: () => console.debug('unsubscribe'),
  })
)
